import { listEpic } from './listEpic';

export const epics = [listEpic];
